import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { FiLayers, FiVideo, FiEdit, FiHelpCircle, FiPaperclip } from 'react-icons/fi';

import { useCourseData } from '../hooks/useCourseData';
import { useContentCourse } from '../context/ContentContext';

import {
  Container,
  Title,
  CourseBar,
  CourseSelect,
  CourseLabel,
  TabContainer,
  TabLink,
  Content,
} from './ContentLayout.styles';

const TABS = [
  { path: 'video', label: 'Vídeo da Aula', icon: FiVideo },
  { path: 'exercise', label: 'Exercício', icon: FiEdit },
  { path: 'quiz', label: 'Quiz no Vídeo', icon: FiHelpCircle },
  { path: 'materials', label: 'Materiais', icon: FiPaperclip },
];

/**
 * Casca do Cadastro de Conteúdo: o curso é escolhido uma vez, no topo, e vale
 * para todas as abas. Cada aba é uma sub-rota com URL própria.
 */
const ContentLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { courses, loadingCourses } = useCourseData();
  const { courseId, setCourseId } = useContentCourse();
  const { url } = useRouteMatch();

  return (
    <Container>
      <Title>Cadastro de Conteúdo</Title>

      <CourseBar>
        <CourseLabel htmlFor="content-course">Curso</CourseLabel>
        <CourseSelect
          id="content-course"
          value={courseId}
          disabled={loadingCourses}
          onChange={(e) => setCourseId(e.target.value)}
        >
          <option value="">
            {loadingCourses ? 'Carregando cursos...' : '— Selecione o curso —'}
          </option>
          {courses.map((course) => (
            <option key={course.courseid} value={course.courseid}>
              {course.title}
            </option>
          ))}
        </CourseSelect>
      </CourseBar>

      <TabContainer role="tablist" aria-label="Tipo de conteúdo">
        <TabLink to={`${url}/module`} activeClassName="active" role="tab">
          <FiLayers aria-hidden />
          Módulo
        </TabLink>
        {TABS.map(({ path, label, icon: Icon }) => (
          <TabLink key={path} to={`${url}/${path}`} activeClassName="active" role="tab">
            <Icon aria-hidden />
            {label}
          </TabLink>
        ))}
      </TabContainer>

      <Content>{children}</Content>
    </Container>
  );
};

export default ContentLayout;
